import React from 'react';
import { EMAIL_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PRODUCT_SLIDE, PROFILE_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, START_SLIDE } from '../quiz-component-types';
import pauseCollageUnderratingSrc from '../../assets/images/slide/pause-collage-underrating.png';
import pauseCollageOrdinarySrc from '../../assets/images/slide/pause-collage-ordinary.png';
import pauseCollageQuestionSrc from '../../assets/images/slide/pause-collage-question.png';
import pauseCollageAlbumSrc from '../../assets/images/slide/pause-collage-album.png';
import startCardALittleSrc from '../../assets/images/slide/start-card-a-little.png';
import startCardVeryCuriousSrc from '../../assets/images/slide/start-card-very-curious.png';

const QUIZ_SLIDES_V32 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true,
        props: {
            startQuestion: {
                id: 901,
                question: 'Curious what your life adds up to?',
                answers: [
                    {
                        text: 'A little',
                        imageSrc: startCardALittleSrc,
                        id: 1
                    },
                    {
                        text: 'Very curious',
                        imageSrc: startCardVeryCuriousSrc,
                        id: 2
                    }
                ]
            }
        }
    },
    {
        id: 9031,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true,
            label: 'Let’s go'
        },
        props: {
            variant: 'v10',
            imageSrc: pauseCollageUnderratingSrc,
            heading: 'You might be underrating your own life',
            description: <>This quick test looks at the people, choices, and moments that made it yours. <br /><br />{'At the end, you’ll get your '}<strong>Life Richness score</strong>{' and a name for the kind of life you’ve lived.'}</>,
            highlightIcon: 'point-up',
            highlightText: 'Nothing to write. Just choose what feels true.'
        }
    },
    {
        id: 9032,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Little Things',
            question: 'Have you ever stayed up talking until the sun came up?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'smile',
                    id: 1,
                    score: 4
                },
                {
                    text: 'Not yet',
                    icon: 'sleepy-face',
                    id: 2,
                    score: 1
                }
            ]
        }
    },
    {
        id: 9033,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Little Things',
            question: 'Have you ever kept a completely useless object because of the story behind it?',
            answers: [
                {
                    text: 'Yes - more than one',
                    icon: 'thumbs-up',
                    id: 1,
                    score: 4
                },
                {
                    text: 'One, and I know exactly where it is',
                    icon: 'pushpin',
                    id: 2,
                    score: 3
                },
                {
                    text: 'I throw things out',
                    icon: 'trash-bin',
                    id: 3,
                    score: 1
                }
            ]
        }
    },
    {
        id: 9034,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Little Things',
            question: 'Have you ever had a completely ordinary day you still remember years later?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'hundred-points',
                    id: 1,
                    score: 4
                },
                {
                    text: 'Not that I can name',
                    icon: 'thinking-face',
                    id: 2,
                    score: 1
                }
            ]
        }
    },
    {
        id: 9035,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v10',
            imageSrc: pauseCollageOrdinarySrc,
            heading: 'Of course your own life feels ordinary to you',
            description: <>You were there for all of it. Of course a late-night conversation, an object you kept, or one ordinary day doesn&apos;t <strong>{'feel like a "story."'}</strong> <br /><br />That doesn&apos;t make it any less worth telling.</>
        }
    },
    {
        id: 9036,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Fun Stuff',
            question: 'Do you have a weird, slightly useless hidden talent?',
            answers: [
                {
                    text: 'Yes, and it always lands',
                    icon: 'target',
                    id: 1,
                    score: 5
                },
                {
                    text: 'One, but it’s very niche',
                    icon: 'performing-arts',
                    id: 2,
                    score: 4
                },
                {
                    text: 'Nothing I’d perform in public',
                    icon: 'zipper-mouth-face',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9037,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Fun Stuff',
            question: 'Do you have stories from your twenties that would still shock your parents?',
            answers: [
                {
                    text: 'Yes, a few of them',
                    icon: 'laughing',
                    id: 1,
                    score: 5
                },
                {
                    text: 'No — I was the good one',
                    icon: 'relieved-face',
                    id: 2,
                    score: 3
                }
            ]
        }
    },
    {
        id: 9038,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Fun Stuff',
            question: 'Have you ever laughed at the worst possible moment?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'grimacing-face',
                    id: 1,
                    score: 5
                },
                {
                    text: 'Somehow, no',
                    icon: 'halo',
                    id: 2,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9039,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Fun Stuff',
            question: 'Have you ever talked your way out of a fine, a ticket, or a very awkward situation?',
            answers: [
                {
                    text: 'Yes, more than once',
                    icon: 'person-raising-hand',
                    id: 1,
                    score: 5
                },
                {
                    text: 'Once, and I was very proud of it',
                    icon: 'trophy',
                    id: 2,
                    score: 4
                },
                {
                    text: 'Not that I’d admit here',
                    icon: 'zipper-mouth-face',
                    id: 3,
                    score: 3
                }
            ]
        }
    },
    {
        id: 9040,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Fun Stuff',
            question: 'Looking back — did you follow the rules, or bend them?',
            answers: [
                {
                    text: 'I bent quite a few',
                    icon: 'imp',
                    id: 1,
                    score: 5
                },
                {
                    text: 'I mostly followed them',
                    icon: 'halo',
                    id: 2,
                    score: 3
                }
            ]
        }
    },
    {
        id: 9042,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v12'
        }
    },
    {
        id: 9043,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Plot Twists',
            question: 'Have you ever met someone by chance who changed everything?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'handshake',
                    id: 1,
                    score: 7
                },
                {
                    text: 'Not yet',
                    icon: 'disappointed-face',
                    id: 2,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9044,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Plot Twists',
            question: 'Have you ever taken a trip that went completely off-plan?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'luggage',
                    id: 1,
                    score: 7
                },
                {
                    text: 'Not yet',
                    icon: 'world-map',
                    id: 2,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9045,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Plot Twists',
            question: 'Have you ever walked away from something and never looked back?',
            answers: [
                {
                    text: 'Yes — and it was the right call',
                    icon: 'door',
                    id: 1,
                    score: 7
                },
                {
                    text: 'No, I stay and fix things',
                    icon: 'anchor',
                    id: 2,
                    score: 4
                }
            ]
        }
    },
    {
        id: 9046,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Plot Twists',
            question: 'Has your love life had a twist nobody saw coming?',
            answers: [
                {
                    text: 'Oh, definitely',
                    icon: 'heart-with-arrow',
                    id: 1,
                    score: 7
                },
                {
                    text: 'No — and I’d choose it again',
                    icon: 'yellow-heart',
                    id: 2,
                    score: 4
                }
            ]
        }
    },
    {
        id: 9047,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v10',
            imageSrc: pauseCollageQuestionSrc,
            heading: 'See? No blank page.',
            description: <>{'A person, a trip, a decision, a turn you didn’t expect — you’ve already found several places a story could begin.'}<br /><br /><strong>The right question</strong>{' gives you somewhere to start. What comes next is the part only you can tell.'}</>
        }
    },
    {
        id: 9048,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Only You Could Tell',
            question: 'Have you ever told a story that starts with “you had to be there”?',
            answers: [
                {
                    text: 'Oh, absolutely',
                    icon: 'laughing-tears',
                    id: 1,
                    score: 6
                },
                {
                    text: 'Not my style',
                    icon: 'neutral-face',
                    id: 2,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9049,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Only You Could Tell',
            question: 'Have you ever ended up somewhere you had absolutely no business being?',
            answers: [
                {
                    text: 'Yes, more than once',
                    icon: 'mind-blown',
                    id: 1,
                    score: 6
                },
                {
                    text: 'Once, and I still tell that story',
                    icon: 'books',
                    id: 2,
                    score: 5
                },
                {
                    text: 'Not that I’d admit here',
                    icon: 'zipper-mouth-face',
                    id: 3,
                    score: 3
                }
            ]
        }
    },
    {
        id: 9050,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Only You Could Tell',
            question: 'Is there something you know that nobody else in your family does?',
            answers: [
                {
                    text: 'Yes, at least one',
                    icon: 'hand-over-mouth',
                    id: 1,
                    score: 6
                },
                {
                    text: 'Nothing like that',
                    icon: 'smiling-face-tear',
                    id: 2,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9051,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Only You Could Tell',
            question: 'How often does something come back to you out of nowhere — a smell, a song, a room?',
            answers: [
                {
                    text: 'Almost never',
                    icon: 'blank-face',
                    id: 1,
                    score: 1
                },
                {
                    text: 'Rarely',
                    icon: 'neutral-face',
                    id: 2,
                    score: 2
                },
                {
                    text: 'Quite often',
                    icon: 'smile',
                    id: 3,
                    score: 3
                },
                {
                    text: 'Almost always',
                    icon: 'grinning-face',
                    id: 4,
                    score: 4
                }
            ]
        }
    },
    {
        id: 9052,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v10',
            imageSrc: pauseCollageAlbumSrc,
            heading: 'It’s never the wedding',
            description: <>{'It’s what the kitchen smelled like that morning. What your father said in the car. The argument at twenty-four and who talked you into staying.'}<br /><br /><strong>Nobody writes those down.</strong></>,
            highlightIcon: 'mic-old',
            highlightText: 'They are also the only parts that sound like you.'
        }
    },
    {
        id: 944,
        component: PLAN_LOADER_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotIndexing: true,
        props: {
            title: <>Your <em>Life Richness Profile</em> is ready</>,
            description: 'Enter your email to see your result',
            placeholder: 'Enter your email'
        }
    },
    {
        id: 946,
        component: PROFILE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 947,
        component: PRODUCT_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v5'
        }
    },
    {
        id: 948,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Would you like to add photos along the way?',
            answers: [
                {
                    text: 'Yes',
                    icon: 'check-mark-button',
                    id: 1
                },
                {
                    text: 'Maybe later',
                    icon: 'camera',
                    id: 2
                },
                {
                    text: 'No — words are enough for me',
                    icon: 'writing',
                    id: 3
                }
            ]
        }
    },
    {
        id: 949,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'How would you like to answer?',
            answers: [
                {
                    text: 'Speak - it’s easier to talk',
                    icon: 'speaking-head',
                    id: 1
                },
                {
                    text: 'Type - I like to think as I write',
                    icon: 'pencil',
                    id: 2
                },
                {
                    text: 'Both - I’ll decide each time',
                    icon: 'thinking-face',
                    id: 3
                }
            ]
        }
    },
    {
        id: 908,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Where would you like to begin?',
            answers: [
                {
                    text: 'Early Childhood & Roots',
                    icon: 'baby',
                    id: 1
                },
                {
                    text: 'School Years',
                    icon: 'books',
                    id: 2
                },
                {
                    text: 'Youth & Student Years',
                    icon: 'graduation-cap',
                    id: 3
                },
                {
                    text: 'Early Adulthood',
                    icon: 'couple',
                    id: 4
                },
                {
                    text: 'Starting a Family',
                    icon: 'family',
                    id: 5
                },
                {
                    text: 'Maturity & Career',
                    icon: 'briefcase',
                    id: 6
                },
                {
                    text: 'The Golden Years',
                    icon: 'old-man',
                    id: 7
                }
            ]
        }
    },
    {
        id: 950,
        component: PLAN_GRAPH_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    }
];

export {
    QUIZ_SLIDES_V32
};
